import axios from './axios-instance';

export default {
  login: (email, password) => {
    return axios.post('api/treasurer/seller/login', {email, password});
  },
  requestAuthCode: phoneNumber => {
    return axios.get(`/login/authcode?phoneNumber=${phoneNumber}`);
  },
  logout: accessToken => {
    // 임시 api
    return axios.post('/logout', {accessToken});
  },
};
